import { WifiOff, Clock, RefreshCw } from 'lucide-react';
import { useConnectivity } from './ConnectivityContext';

// Shell-level, mounted once in AppContainer.jsx -- shows on every route
// whenever the persistent health-check loop (ConnectivityContext) detects a
// problem, not just at cold start (that's AppContainer's separate, existing
// blocking `initializationError` race, untouched by this).
export default function ConnectivityBanner() {
  const { status, latencyMs, checkNow } = useConnectivity();

  if (status === 'online') return null;

  const isOffline = status === 'offline';

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed bottom-0 inset-x-0 z-[10000] flex items-center justify-center gap-3 px-4 py-2.5 text-sm font-medium text-white shadow-[0_-2px_10px_rgba(0,0,0,0.15)] ${
        isOffline ? 'bg-red-600' : 'bg-amber-600'
      }`}
    >
      {isOffline ? <WifiOff className="w-4 h-4 flex-shrink-0" /> : <Clock className="w-4 h-4 flex-shrink-0" />}
      <span>
        {isOffline
          ? "You're offline -- reconnecting…"
          : `Slow connection${latencyMs ? ` (${latencyMs}ms)` : ''} -- some pages may take longer to load`}
      </span>
      <button
        type="button"
        onClick={checkNow}
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-white/15 hover:bg-white/25 transition-colors"
      >
        <RefreshCw className="w-3.5 h-3.5" />
        Retry now
      </button>
    </div>
  );
}
